var _path, _path2, _path3, _path4, _g, _g2, _path5, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaSmallIcon05(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_3714)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7365 9.09886C26.3776 8.45766 26.7379 7.58802 26.7379 6.68124C26.7379 5.77445 26.3776 4.90481 25.7365 4.26362C25.0953 3.62243 24.2256 3.26221 23.3188 3.26221C22.412 3.26221 21.5424 3.62243 20.9012 4.26362L9.32181 15.843C9.19954 15.9653 9.13086 16.1312 9.13086 16.3041C9.13086 16.477 9.19954 16.6429 9.32181 16.7652L13.2349 20.6783C13.3572 20.8005 13.523 20.8692 13.696 20.8692C13.8689 20.8692 14.0347 20.8005 14.157 20.6783L25.7365 9.09886Z",
    fill: "url(#paint0_linear_743_3714)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7817 26.0872C8.22552 26.0855 6.73357 25.4665 5.63318 24.3661C4.53279 23.2657 3.91384 21.7738 3.91211 20.2176C3.91211 20.0446 3.98082 19.8788 4.10313 19.7564C4.22543 19.6341 4.39132 19.5654 4.56429 19.5654C4.73725 19.5654 4.90314 19.6341 5.02544 19.7564C5.14775 19.8788 5.21646 20.0446 5.21646 20.2176C5.21802 21.4279 5.69949 22.5882 6.55531 23.444C7.41112 24.2998 8.5714 24.7813 9.7817 24.7828C9.95467 24.7828 10.1206 24.8516 10.2429 24.9739C10.3652 25.0962 10.4339 25.2621 10.4339 25.435C10.4339 25.608 10.3652 25.7739 10.2429 25.8962C10.1206 26.0185 9.95467 26.0872 9.7817 26.0872Z",
    fill: "url(#paint1_linear_743_3714)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87891 4.56559L5.86979 1.57471L7.55632 3.26124L4.56544 6.25212L2.87891 4.56559ZM5.48761 7.1743L8.4785 4.18341L10.165 5.86994L7.17414 8.86083L5.48761 7.1743ZM9.78285 11.4695L8.09632 9.78301L11.0872 6.79212L12.7737 8.47865L9.78285 11.4695Z",
    fill: "url(#paint2_linear_743_3714)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4261 24.1305L25.4352 27.1214L23.7487 25.4349L26.7395 22.444L28.4261 24.1305ZM25.8174 21.5218L22.8265 24.5127L21.14 22.8262L24.1308 19.8353L25.8174 21.5218ZM21.5221 17.2266L23.2087 18.9131L20.2178 21.904L18.5312 20.2174L21.5221 17.2266Z",
    fill: "url(#paint3_linear_743_3714)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.13086,
    y: 0.262207,
    width: 23.6069,
    height: 23.6071
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_1_743_3714_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_743_3714)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7365 9.09886C26.3776 8.45766 26.7379 7.58802 26.7379 6.68124C26.7379 5.77445 26.3776 4.90481 25.7365 4.26362C25.0953 3.62243 24.2256 3.26221 23.3188 3.26221C22.412 3.26221 21.5424 3.62243 20.9012 4.26362L9.32181 15.843C9.19954 15.9653 9.13086 16.1312 9.13086 16.3041C9.13086 16.477 9.19954 16.6429 9.32181 16.7652L13.2349 20.6783C13.3572 20.8005 13.523 20.8692 13.696 20.8692C13.8689 20.8692 14.0347 20.8005 14.157 20.6783L25.7365 9.09886Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7365 9.09886C26.3776 8.45766 26.7379 7.58802 26.7379 6.68124C26.7379 5.77445 26.3776 4.90481 25.7365 4.26362C25.0953 3.62243 24.2256 3.26221 23.3188 3.26221C22.412 3.26221 21.5424 3.62243 20.9012 4.26362L9.32181 15.843C9.19954 15.9653 9.13086 16.1312 9.13086 16.3041C9.13086 16.477 9.19954 16.6429 9.32181 16.7652L13.2349 20.6783C13.3572 20.8005 13.523 20.8692 13.696 20.8692C13.8689 20.8692 14.0347 20.8005 14.157 20.6783L25.7365 9.09886Z",
    fill: "url(#paint4_linear_743_3714)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3184 3.76221C24.0924 3.76221 24.8354 4.06945 25.3828 4.6167C25.9302 5.1641 26.2383 5.90701 26.2383 6.68115C26.2383 7.45533 25.9302 8.19818 25.3828 8.74561L13.8037 20.3247C13.7753 20.3532 13.7365 20.3695 13.6963 20.3696C13.6561 20.3696 13.6174 20.3531 13.5889 20.3247L9.67578 16.4116C9.64727 16.3831 9.63088 16.3445 9.63086 16.3042C9.63086 16.2638 9.64725 16.2253 9.67578 16.1968L21.2549 4.6167C21.8022 4.06957 22.5445 3.76233 23.3184 3.76221Z",
    stroke: "url(#paint5_linear_743_3714)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.69531,
    y: -3,
    width: 19.0432,
    height: 19.0432
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_2_743_3714_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_743_3714)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6616 10.4347L14.157 8.93925C14.2793 8.81695 14.3479 8.6511 14.3479 8.47816C14.3479 8.30523 14.2793 8.13937 14.157 8.01707L6.33088 0.190949C6.20857 0.0686843 6.04272 0 5.86979 0C5.69685 0 5.531 0.0686843 5.4087 0.190949L1.49564 4.10401C1.37337 4.22631 1.30469 4.39217 1.30469 4.5651C1.30469 4.73803 1.37337 4.90389 1.49564 5.02619L9.32176 12.8523C9.44406 12.9746 9.60991 13.0433 9.78285 13.0433C9.95578 13.0433 10.1216 12.9746 10.2439 12.8523L11.7394 11.3569L12.7737 12.3912L13.6959 11.469L12.6616 10.4347Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6616 10.4347L14.157 8.93925C14.2793 8.81695 14.3479 8.6511 14.3479 8.47816C14.3479 8.30523 14.2793 8.13937 14.157 8.01707L6.33088 0.190949C6.20857 0.0686843 6.04272 0 5.86979 0C5.69685 0 5.531 0.0686843 5.4087 0.190949L1.49564 4.10401C1.37337 4.22631 1.30469 4.39217 1.30469 4.5651C1.30469 4.73803 1.37337 4.90389 1.49564 5.02619L9.32176 12.8523C9.44406 12.9746 9.60991 13.0433 9.78285 13.0433C9.95578 13.0433 10.1216 12.9746 10.2439 12.8523L11.7394 11.3569L12.7737 12.3912L13.6959 11.469L12.6616 10.4347Z",
    fill: "url(#paint6_linear_743_3714)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87012 0.5C5.91035 0.500087 5.94908 0.516471 5.97754 0.544922L13.8037 8.37109V8.37012C13.8322 8.39865 13.8477 8.43816 13.8477 8.47852C13.8476 8.51871 13.8321 8.55749 13.8037 8.58594L12.3076 10.0811L11.9541 10.4346L12.9883 11.4688L12.7734 11.6836L11.7393 10.6494L11.3857 11.0029L9.89062 12.499C9.86218 12.5274 9.8234 12.5429 9.7832 12.543C9.74305 12.543 9.70428 12.5273 9.67578 12.499L1.84961 4.67285C1.82116 4.64439 1.80477 4.60566 1.80469 4.56543C1.80469 4.52511 1.82014 4.48556 1.84863 4.45703L1.84961 4.45801L5.7627 0.544922L5.76172 0.543945C5.79025 0.515457 5.8298 0.5 5.87012 0.5Z",
    stroke: "url(#paint7_linear_743_3714)",
    strokeOpacity: 0.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78265 30.0003C7.18903 29.9973 4.70248 28.9657 2.86851 27.1317C1.03455 25.2978 0.00293445 22.8112 0 20.2176C0 20.0446 0.0687113 19.8788 0.191018 19.7564C0.313325 19.6341 0.479209 19.5654 0.652177 19.5654C0.825145 19.5654 0.991029 19.6341 1.11334 19.7564C1.23564 19.8788 1.30435 20.0446 1.30435 20.2176C1.30694 22.4654 2.20102 24.6204 3.79045 26.2098C5.37988 27.7992 7.53486 28.6933 9.78265 28.6959C9.95562 28.6959 10.1215 28.7646 10.2438 28.8869C10.3661 29.0092 10.4348 29.1751 10.4348 29.3481C10.4348 29.5211 10.3661 29.6869 10.2438 29.8092C10.1215 29.9316 9.95562 30.0003 9.78265 30.0003Z",
    fill: "url(#paint8_linear_743_3714)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -3,
    y: 16.5654,
    width: 16.4348,
    height: 16.4348
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_3_743_3714_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_743_3714)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78265 30.0003C7.18903 29.9973 4.70248 28.9657 2.86851 27.1317C1.03455 25.2978 0.00293445 22.8112 0 20.2176C0 20.0446 0.0687113 19.8788 0.191018 19.7564C0.313325 19.6341 0.479209 19.5654 0.652177 19.5654C0.825145 19.5654 0.991029 19.6341 1.11334 19.7564C1.23564 19.8788 1.30435 20.0446 1.30435 20.2176C1.30694 22.4654 2.20102 24.6204 3.79045 26.2098C5.37988 27.7992 7.53486 28.6933 9.78265 28.6959C9.95562 28.6959 10.1215 28.7646 10.2438 28.8869C10.3661 29.0092 10.4348 29.1751 10.4348 29.3481C10.4348 29.5211 10.3661 29.6869 10.2438 29.8092C10.1215 29.9316 9.95562 30.0003 9.78265 30.0003Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78265 30.0003C7.18903 29.9973 4.70248 28.9657 2.86851 27.1317C1.03455 25.2978 0.00293445 22.8112 0 20.2176C0 20.0446 0.0687113 19.8788 0.191018 19.7564C0.313325 19.6341 0.479209 19.5654 0.652177 19.5654C0.825145 19.5654 0.991029 19.6341 1.11334 19.7564C1.23564 19.8788 1.30435 20.0446 1.30435 20.2176C1.30694 22.4654 2.20102 24.6204 3.79045 26.2098C5.37988 27.7992 7.53486 28.6933 9.78265 28.6959C9.95562 28.6959 10.1215 28.7646 10.2438 28.8869C10.3661 29.0092 10.4348 29.1751 10.4348 29.3481C10.4348 29.5211 10.3661 29.6869 10.2438 29.8092C10.1215 29.9316 9.95562 30.0003 9.78265 30.0003Z",
    fill: "url(#paint9_linear_743_3714)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.652344 20.0654C0.692644 20.0655 0.731267 20.0819 0.759766 20.1104C0.788199 20.1389 0.804688 20.1775 0.804688 20.2178L0.81543 20.6631C0.927831 22.8812 1.85871 24.9856 3.43652 26.5635C5.01435 28.1413 7.11888 29.0721 9.33691 29.1846L9.78223 29.1963C9.82259 29.1963 9.86209 29.2117 9.89062 29.2402C9.91902 29.2687 9.93446 29.3075 9.93457 29.3477C9.93457 29.388 9.91916 29.4275 9.89062 29.4561C9.86209 29.4846 9.82259 29.499 9.78223 29.499C7.32138 29.496 4.96178 28.5184 3.22168 26.7783C1.4816 25.0382 0.502978 22.6787 0.5 20.2178C0.5 20.1774 0.516384 20.1389 0.544922 20.1104C0.57346 20.0818 0.611983 20.0654 0.652344 20.0654Z",
    stroke: "url(#paint10_linear_743_3714)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 13.957,
    y: 12.6523,
    width: 19.0432,
    height: 19.0432
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.5px)",
      clipPath: "url(#bgblur_4_743_3714_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_743_3714)",
    "data-figma-bg-blur-radius": 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6434 18.2609L17.148 19.7564C17.0257 19.8787 16.957 20.0445 16.957 20.2174C16.957 20.3904 17.0257 20.5562 17.148 20.6785L24.9741 28.5047C25.0964 28.6269 25.2623 28.6956 25.4352 28.6956C25.6081 28.6956 25.774 28.6269 25.8963 28.5047L29.8093 24.5916C29.9316 24.4693 30.0003 24.3034 30.0003 24.1305C30.0003 23.9576 29.9316 23.7917 29.8093 23.6694L21.9832 15.8433C21.8609 15.721 21.6951 15.6523 21.5221 15.6523C21.3492 15.6523 21.1833 15.721 21.061 15.8433L19.5656 17.3387L18.5312 16.3044L17.6091 17.2266L18.6434 18.2609Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6434 18.2609L17.148 19.7564C17.0257 19.8787 16.957 20.0445 16.957 20.2174C16.957 20.3904 17.0257 20.5562 17.148 20.6785L24.9741 28.5047C25.0964 28.6269 25.2623 28.6956 25.4352 28.6956C25.6081 28.6956 25.774 28.6269 25.8963 28.5047L29.8093 24.5916C29.9316 24.4693 30.0003 24.3034 30.0003 24.1305C30.0003 23.9576 29.9316 23.7917 29.8093 23.6694L21.9832 15.8433C21.8609 15.721 21.6951 15.6523 21.5221 15.6523C21.3492 15.6523 21.1833 15.721 21.061 15.8433L19.5656 17.3387L18.5312 16.3044L17.6091 17.2266L18.6434 18.2609Z",
    fill: "url(#paint11_linear_743_3714)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5225 16.1523C21.5627 16.1524 21.6014 16.1688 21.6299 16.1973L29.4561 24.0234V24.0225C29.4846 24.051 29.5 24.0905 29.5 24.1309C29.4999 24.1711 29.4845 24.2098 29.4561 24.2383L25.543 28.1514C25.5145 28.1798 25.4757 28.1952 25.4355 28.1953C25.3954 28.1953 25.3566 28.1796 25.3281 28.1514L17.502 20.3252C17.4735 20.2967 17.4571 20.258 17.457 20.2178C17.457 20.1775 17.4725 20.1379 17.501 20.1094L17.502 20.1104L18.9971 18.6143L19.3506 18.2607L18.3164 17.2266L18.5312 17.0117L19.5654 18.0459L19.9189 17.6924L21.415 16.1973L21.4141 16.1963C21.4426 16.1678 21.4821 16.1523 21.5225 16.1523Z",
    stroke: "url(#paint12_linear_743_3714)",
    strokeOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_743_3714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6345 7.36471C22.5115 7.24592 22.3468 7.18018 22.1758 7.18167C22.0048 7.18315 21.8412 7.25174 21.7203 7.37266C21.5994 7.49358 21.5308 7.65715 21.5293 7.82815C21.5278 7.99915 21.5936 8.16389 21.7124 8.28689L24.13 10.7045L25.0522 9.78233L22.6345 7.36471Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_743_3714",
    x: 6.13086,
    y: 0.262207,
    width: 23.6069,
    height: 23.6071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3714"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_743_3714_clip_path",
    transform: "translate(-6.13086 -0.262207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7365 9.09886C26.3776 8.45766 26.7379 7.58802 26.7379 6.68124C26.7379 5.77445 26.3776 4.90481 25.7365 4.26362C25.0953 3.62243 24.2256 3.26221 23.3188 3.26221C22.412 3.26221 21.5424 3.62243 20.9012 4.26362L9.32181 15.843C9.19954 15.9653 9.13086 16.1312 9.13086 16.3041C9.13086 16.477 9.19954 16.6429 9.32181 16.7652L13.2349 20.6783C13.3572 20.8005 13.523 20.8692 13.696 20.8692C13.8689 20.8692 14.0347 20.8005 14.157 20.6783L25.7365 9.09886Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_743_3714",
    x: -1.69531,
    y: -3,
    width: 19.0432,
    height: 19.0432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3714"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_743_3714_clip_path",
    transform: "translate(1.69531 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6616 10.4347L14.157 8.93925C14.2793 8.81695 14.3479 8.6511 14.3479 8.47816C14.3479 8.30523 14.2793 8.13937 14.157 8.01707L6.33088 0.190949C6.20857 0.0686843 6.04272 0 5.86979 0C5.69685 0 5.531 0.0686843 5.4087 0.190949L1.49564 4.10401C1.37337 4.22631 1.30469 4.39217 1.30469 4.5651C1.30469 4.73803 1.37337 4.90389 1.49564 5.02619L9.32176 12.8523C9.44406 12.9746 9.60991 13.0433 9.78285 13.0433C9.95578 13.0433 10.1216 12.9746 10.2439 12.8523L11.7394 11.3569L12.7737 12.3912L13.6959 11.469L12.6616 10.4347Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_743_3714",
    x: -3,
    y: 16.5654,
    width: 16.4348,
    height: 16.4348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3714"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_743_3714_clip_path",
    transform: "translate(3 -16.5654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78265 30.0003C7.18903 29.9973 4.70248 28.9657 2.86851 27.1317C1.03455 25.2978 0.00293445 22.8112 0 20.2176C0 20.0446 0.0687113 19.8788 0.191018 19.7564C0.313325 19.6341 0.479209 19.5654 0.652177 19.5654C0.825145 19.5654 0.991029 19.6341 1.11334 19.7564C1.23564 19.8788 1.30435 20.0446 1.30435 20.2176C1.30694 22.4654 2.20102 24.6204 3.79045 26.2098C5.37988 27.7992 7.53486 28.6933 9.78265 28.6959C9.95562 28.6959 10.1215 28.7646 10.2438 28.8869C10.3661 29.0092 10.4348 29.1751 10.4348 29.3481C10.4348 29.5211 10.3661 29.6869 10.2438 29.8092C10.1215 29.9316 9.95562 30.0003 9.78265 30.0003Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_743_3714",
    x: 13.957,
    y: 12.6523,
    width: 19.0432,
    height: 19.0432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3714"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_743_3714_clip_path",
    transform: "translate(-13.957 -12.6523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6434 18.2609L17.148 19.7564C17.0257 19.8787 16.957 20.0445 16.957 20.2174C16.957 20.3904 17.0257 20.5562 17.148 20.6785L24.9741 28.5047C25.0964 28.6269 25.2623 28.6956 25.4352 28.6956C25.6081 28.6956 25.774 28.6269 25.8963 28.5047L29.8093 24.5916C29.9316 24.4693 30.0003 24.3034 30.0003 24.1305C30.0003 23.9576 29.9316 23.7917 29.8093 23.6694L21.9832 15.8433C21.8609 15.721 21.6951 15.6523 21.5221 15.6523C21.3492 15.6523 21.1833 15.721 21.061 15.8433L19.5656 17.3387L18.5312 16.3044L17.6091 17.2266L18.6434 18.2609Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_743_3714",
    x: 21.5293,
    y: 7.18164,
    width: 3.52295,
    height: 4.02283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_743_3714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_3714",
    x1: 9.13086,
    y1: 3.26221,
    x2: 29.8714,
    y2: 8.52861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_3714",
    x1: 3.91211,
    y1: 19.5654,
    x2: 11.5946,
    y2: 21.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_743_3714",
    x1: 2.87891,
    y1: 1.57471,
    x2: 14.5347,
    y2: 4.53433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_3714",
    x1: 18.5313,
    y1: 17.2266,
    x2: 30.1871,
    y2: 20.1862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_743_3714",
    x1: 9.13086,
    y1: 3.26221,
    x2: 29.8714,
    y2: 8.52861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_743_3714",
    x1: 9.68108,
    y1: 4.06253,
    x2: 26.7379,
    y2: 4.06253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_743_3714",
    x1: 1.30469,
    y1: 0,
    x2: 16.6692,
    y2: 3.90135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_743_3714",
    x1: 1.71229,
    y1: 0.592876,
    x2: 14.3479,
    y2: 0.592876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_743_3714",
    x1: 0,
    y1: 19.5654,
    x2: 12.2919,
    y2: 22.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_743_3714",
    x1: 0,
    y1: 19.5654,
    x2: 12.2919,
    y2: 22.6866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_743_3714",
    x1: 0.326089,
    y1: 20.0397,
    x2: 10.4348,
    y2: 20.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_743_3714",
    x1: 16.957,
    y1: 15.6523,
    x2: 32.3216,
    y2: 19.5537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_743_3714",
    x1: 17.3646,
    y1: 16.2452,
    x2: 30.0003,
    y2: 16.2452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_3714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaSmallIcon05);
export default __webpack_public_path__ + "static/media/fea-small-icon05.ce5238e34df753d08baf7eb9f9345745.svg";
export { ForwardRef as ReactComponent };